import React, { useEffect, useState } from 'react';
import { Router } from 'react-router-dom';

import history from './services/history';

import Routes from './routes';

import HamburgerMenu from './components/HamburgerMenu';
import Footer from './components/Footer';
import Loading from './components/Loading';

import GlobalStyle from './styles/global';

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, [loading]);

  return (
    <Router history={history}>
      {
        loading ? <Loading /> :
          <>
            <HamburgerMenu />
            <Routes />
            <Footer />
          </>
      }
      <GlobalStyle />
    </Router>
  );
}
